import styled from 'styled-components';

export const Container = styled.main`
    max-width: 1120px;
    margin: 0 auto;
    padding: 2.5rem 1rem calc(2.5rem + 54px) 1rem;
    h2{
        margin: 2rem 0;
    }
`
